import { TicketApiResponseType } from "apps/registration/types/regFormApiResponse";
import { RegistrationRoute } from "apps/registration/routes/route";
import React from "react";
import { useSearchParams } from "react-router-dom";
import { useRegDetail } from "shared/context/regDetail";
import { Base64Util } from "shared/utils/base64";
import { TicketListAccumulaterType } from "./type";
import { getAllUtmSearchParams, convertObjectToQueryString, isBuyerAttendee } from "apps/registration/utils";
import QueryParamKey from "../../../../shared/enums/QueryParamKey";

export default function useTicketPageService(ticketList: TicketApiResponseType[]) {
  const { registrationUrl } = useRegDetail();
  const [searchParams] = useSearchParams();

  const { hostedTickets, applicationOrPaymentTickets, nonAttendeeTickets } = React.useMemo(() => {
    return ticketList.reduce(
      (acc: TicketListAccumulaterType, t) => {
        if (isBuyerAttendee(t.subRole)) {
          acc.hostedTickets.push(t);
        } else if (t.applicationFlow || t.paymentFlow) {
          acc.applicationOrPaymentTickets.push(t);
        } else {
          acc.nonAttendeeTickets.push(t);
        }

        return acc;
      },
      { hostedTickets: [], applicationOrPaymentTickets: [], nonAttendeeTickets: [] }
    );
  }, [ticketList]);

  const getTicketUrl = React.useCallback(
    ticket => {
      const encodedTicketId = Base64Util.encode(ticket.id);
      let baseTicketUrl = `${registrationUrl}${RegistrationRoute.InitiateReg}?${QueryParamKey.FORM_ID}=${encodedTicketId}`;

      const couponCode = searchParams.get(QueryParamKey.COUPON_CODE);
      const sponsorOrgId = searchParams.get(QueryParamKey.SPONSOR_ORG_ID);
      const utmSearchParams = getAllUtmSearchParams(searchParams);

      if (Object.keys(utmSearchParams).length) {
        baseTicketUrl = baseTicketUrl.concat("&", convertObjectToQueryString(utmSearchParams));
      }
      if (couponCode) {
        return `${baseTicketUrl}&${QueryParamKey.COUPON_CODE}=${couponCode}`;
      }
      if (sponsorOrgId) {
        return `${baseTicketUrl}&${QueryParamKey.SPONSOR_ORG_ID}=${sponsorOrgId}`;
      }
      return baseTicketUrl;
    },
    [registrationUrl, searchParams]
  );

  return { hostedTickets, applicationOrPaymentTickets, nonAttendeeTickets, getTicketUrl };
}
